import {Model} from "vue-mc";

export class Event extends Model{
  defaults() {
    return {
      id: null,
      title: null,
      venue: null,
      mapLatLng: {
        lat: null,
        lng: null,
      },
      publishedAt: null,
      eventAt: null,
    }
  }
}
